import { createSlice } from '@reduxjs/toolkit';
import { ApiEndpointMutation, ApiEndpointQuery } from '@reduxjs/toolkit/dist/query/core/module';
import { fulfilledReducer, pendingReducer, rejectedReducer } from './reducers';
import { ApiSliceState } from './types';

export { default as selectors } from './selectors';
export * from './types';

type EndpointCoreType = {
  [key: string]: ApiEndpointQuery<any, any> | ApiEndpointMutation<any, any>
}

const createApiSlice = (name: string, endpoints: EndpointCoreType) =>  {
  const initialState: ApiSliceState = Object.keys(endpoints).reduce((acc, endpoint) => ({
    ...acc,
    [endpoint]: {},
  }), {});

  return createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      Object.values(endpoints).forEach((endpoint) => {
        builder.addMatcher(endpoint.matchPending, pendingReducer);
        builder.addMatcher(endpoint.matchFulfilled, fulfilledReducer);
        builder.addMatcher(endpoint.matchRejected, rejectedReducer);
      });
    },
  });
}

export default createApiSlice;
